import { css } from '@emotion/react';

export const finalizerCss = (theme) => css`
  color: ${theme.color.surveyText};
  text-align: center;
  .finalizer__email {
    border-radius: 3px;
    display: inline-block;
    margin-top: 16px;
    padding: 0 1em;
    word-break: break-word;
  }
  .finalizer__rule {
    opacity: 0.56;
    max-width: 70%;
  }
  .finalizer__lead {
    font-size: 24px;
    line-height: 48px;
    margin: auto;
    padding: 64px;
    padding-top: 120px;
    @media ${theme.media.phone} {
      padding: 24px;
      padding-top: 80px;
    }
  }
  .finalizer__congratulations {
    color: inherit;
    font-weight: 600;
    font-size: 32px;
    padding: 0;
    padding-bottom: 24px;
    margin: 0;
    text-transform: uppercase;
    @media ${theme.media.phone} {
      font-size: 24px;
    }
  }
  .btn-lg {
    background-color: ${theme.color.white};
    font-weight: 600;
    width: 12em;
    @media ${theme.media.phone} {
      width: 8em;
    }
  }
`;
